import { styled } from 'styled-components';

export const StyledCalendarContainer = styled.div`
  background-color: transparent;
`;
